import React from 'react';
import { connect } from 'react-redux';
import {
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupText,
} from 'reactstrap';

class AgencyInput extends React.PureComponent {
  handleChange = (e) => {
    const agencyId = e.target.id;
    const checkedStatus = e.target.checked;

    const { dispatch } = this.props;
    dispatch({
      type: 'EDIT_ADD_CAMPAIGN',
      id: 'agencies',
      checked: checkedStatus,
      agencyId,
      valid: true,
    });
  };

  render() {
    const {
      agencies,
    } = this.props;

    return (
      <FormGroup>
        <Label for="agencies" className="font-weight-bold">
          Associated Agencies
        </Label>
        <div style={{ maxHeight: '100rem', overflow: 'scroll' }}>
          {
            agencies.map((agency) => (
              <InputGroup>
                <InputGroupText>
                  <Input
                    addon
                    id={agency.id}
                    type="checkbox"
                    aria-label="Checkbox for following text input"
                    onChange={this.handleChange}
                  />
                </InputGroupText>
                <Input placeholder={agency.name} />
              </InputGroup>
            ))
          }
        </div>
      </FormGroup>
    );
  }
}

const mapStateToProps = (store) => ({
  values: store.addcampaign.values,
  validations: store.addcampaign.validations,
  errors: store.addcampaign.errors,
  agencies: store.agencies.records,
});

export default connect(mapStateToProps)(AgencyInput);
